import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import { FC, Fragment, InputHTMLAttributes } from "react";

export type InputWithLinkNextToItprops = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  span?: string;
  error?: boolean;
  textDescribe?: string;
  textError?: string;
  linkUrl: string;
  linkText: string;
};

export const InputWithLinkNextToIt: FC<InputWithLinkNextToItprops> = ({
  label,
  span,
  error,
  textDescribe,
  textError,
  className,
  linkUrl,
  linkText,
  ...props
}) => {
  return (
    <Fragment>
      <div className={className}>
        <div className="flex justify-between">
          <div className="flex items-center">
            <label
              htmlFor={props.id}
              className="block text-sm font-medium leading-6 text-gray-600"
            >
              {label}
            </label>
            {linkUrl && linkText && (
              <a
                href={linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1 text-sm leading-6 text-blue-500 hover:underline-offset-14"
              >
                {linkText}
              </a>
            )}
          </div>

          <span className={`text-sm leading-6 text-gray-500`}>{span}</span>
        </div>
        <div className="relative">
          <input
            {...props}
            className={`px-2 block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ${
              error === true
                ? "ring-red-300 placeholder:text-red-300"
                : "ring-gray-300 placeholder:text-gray-400"
            } focus:ring-2 focus:ring-inset ${
              error === true ? "focus:ring-red-500" : "focus:ring-primary"
            } disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:ring-gray-200 sm:text-sm sm:leading-6`}
          />
          {error === true ? (
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <ExclamationCircleIcon
                aria-hidden="true"
                className="h-5 w-5 text-red-500"
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        {error === true ? (
          <>
            <p className={`mt-1 text-sm text-red-600`}>{textError}</p>
          </>
        ) : (
          <></>
        )}
        <p className={`mt-1 text-sm text-gray-400`}>{textDescribe}</p>
      </div>
    </Fragment>
  );
};
